// client/src/components/horarios/HorarioRow.js (VERSÃO CORRIGIDA - SEM ERRO DE DOM)

import React from 'react';
import { MoreVertical } from 'lucide-react';
import PropTypes from 'prop-types';

const HorarioRow = ({ horario, onOpenActions, isMutating }) => {
    const { horaInicio, horaFim, intervalos, unidade, tipo, diaDaSemana, data } = horario;
    
    const diasDaSemanaMap = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];

    const renderDiaOuData = () => {
        if (tipo === 'SEMANAL') {
            return diasDaSemanaMap[diaDaSemana] || 'Dia inválido';
        }
        return new Date(data).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
    };
    
    const renderTipo = () => {
        switch (tipo) {
            case 'SEMANAL': return <span className="badge badge-gray">Semanal</span>;
            case 'DATA_UNICA': return <span className="badge badge-blue">Data Única</span>;
            default: return <span>{tipo}</span>;
        }
    };

    const formatarIntervalos = () => {
        if (!intervalos || intervalos.length === 0) return <span className="text-gray-500">Sem intervalos</span>;
        return (
            <div className="badge-group">
                {intervalos.map((int, index) => (
                    <span key={index} className="badge badge-gray">{int.inicio} - {int.fim}</span>
                ))}
            </div>
        );
    };

    // JSX Limpo para evitar Warning de Whitespace Node do React
    return (
        <tr className="table-row-hover">
            <td className="td-name">{renderDiaOuData()}</td>
            <td>{renderTipo()}</td>
            <td>{unidade?.nome || 'N/A'}</td>
            <td>{horaInicio}</td>
            <td>{horaFim}</td>
            <td>{formatarIntervalos()}</td>
            <td className="text-right">
                <button type="button" onClick={() => onOpenActions(horario)} title="Ações" className="action-button-icon text-gray-600 hover:text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed" disabled={isMutating}>
                    <MoreVertical size={18} />
                </button>
            </td>
        </tr>
    );
};

HorarioRow.propTypes = {
    horario: PropTypes.object.isRequired,
    onOpenActions: PropTypes.func.isRequired,
    isMutating: PropTypes.bool
};

export default HorarioRow;